import { useEffect } from 'react';
import './style.css';
import { FieldValues, useForm } from 'react-hook-form';
import { Button, HStack, Span, VStack } from '@bpba/ui-components';
import { GrFormClose } from 'react-icons/gr';
import debounce from 'debounce';
import { TIPO_PACTAR } from '../../Constantes';
import { useQuery } from '@apollo/client';
import { getRubros } from '../../rest/queries/getRubros';
import { getLocalidades } from '../../rest/queries/getLocalidades';
import { getRegiones } from '../../rest/queries/getRegiones';


type FiltroProps = {
  onSubmit: (data: FieldValues) => void;
  onChangeTrigger?: boolean;
  tipo: string;
  defaults?: FieldValues;
  muestraLocalidad: boolean;
};

const Filtro = ({ onSubmit, onChangeTrigger = false, tipo, defaults, muestraLocalidad }: FiltroProps) => {
  const { register, handleSubmit, watch, setValue } = useForm({ mode: 'onBlur', defaultValues: defaults });
  const tipoBuscador = tipo === TIPO_PACTAR ? 1 : 2;

  const { data: { rubros } = {} } = useQuery(getRubros, {
    variables: { tipoBuscador },
  });
  const { data: { localidades } = {} } = useQuery(getLocalidades, {
    variables: { tipoBuscador },
  });
  const { data: { regiones } = {} } = useQuery(getRegiones, {
    variables: { tipoBuscador },
  });

  useEffect(() => {
    if (onChangeTrigger) {
      const suscribe = watch(
        debounce((data: FieldValues) => {
          onSubmit(data);
        }, 500)
      );
      return () => suscribe.unsubscribe();
    }
  }, [watch, onChangeTrigger, onSubmit]);
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <VStack>
        <VStack my={1}>
          <Span color="secondary" fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>Denominación</Span>
          <HStack alignItems="stretch" flexGrow={1}>
            <input {...register('denominacion')} id="denominacion" placeholder="INGRESÁ NOMBRE COMERCIAL" type="text"></input>
            <HStack width="auto" bg="white" justifyContent="center" borderBottom="1px solid" borderColor="secondary.1">
              <GrFormClose size="24" onClick={() => setValue('denominacion', '')} />
            </HStack>
          </HStack>
        </VStack>

        {tipo === TIPO_PACTAR &&
          <VStack my={1}>
            <Span color="secondary" fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>Región</Span>
            <select {...register('region')} id="region">
              <option value="">TODAS</option>
              {regiones?.map((region: any) => (
                <option key={region.id} value={region.id}>{region.descripcion}</option>))}
            </select>
          </VStack>}

        <VStack my={1}>
          <Span color="secondary" fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>Rubro</Span>
          <select {...register('rubro')} id="rubro">
            <option value="">TODOS</option>
            {rubros?.map((rubro: any) => (
              <option key={rubro.codigo} value={rubro.codigo}>{rubro.descripcion}</option>))}
          </select>
        </VStack>

        {muestraLocalidad && ( 
          <VStack my={1}>
            <Span color="secondary" fontSize={"14px"} marginBottom={"8px"} style={{ lineHeight: "18px" }} tabIndex={0}>Localidades</Span>
            <select {...register('localidad')} id="localidad">
              <option value="">TODAS</option>
              {localidades?.map((localidad: any) => (
                <option key={localidad.id} value={localidad.id}> {localidad.descripcion}</option>))}
            </select>
          </VStack>
        )}

        {!onChangeTrigger && (
          <VStack mt={2}>
            <Button variant="secondary" type="submit">
              Aplicar
            </Button>
          </VStack>
        )}
      </VStack>
    </form>
  );
};
export default Filtro;
